import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import { Spin } from 'antd';

const Dashboard      = lazy(() => import('../../container/datamining/Index'));
const AudioPage     = lazy(() => import('../../container/datamining/AudioPage'));
// const PushLead       = lazy(() => import('../../container/datamining/PushLead'));

function DataMiningRoutes() {
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>  
            }
        >
            <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="mining_audio" element={<AudioPage />} />
                {/* <Route path="push_lead" element={<PushLead />} /> */}
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(DataMiningRoutes);
